export const DEFAULT_API_BASE_URL = 'https://chat.webhelloworld.it';
export function normalizeBaseUrl(value) {
    const raw = String(value || '').trim();
    if (!raw)
        return DEFAULT_API_BASE_URL;
    return raw.replace(/\/+$/, '');
}
export async function loadRuntimeConfig(fetcher = fetch) {
    try {
        const res = await fetcher('/runtime-config.json', { cache: 'no-store' });
        if (!res.ok)
            throw new Error(`runtime config ${res.status}`);
        const data = (await res.json());
        return {
            appName: data.appName || 'SkyChat',
            apiBaseUrl: normalizeBaseUrl(data.apiBaseUrl || DEFAULT_API_BASE_URL),
            debug: data.debug === true
        };
    }
    catch {
        return {
            appName: 'SkyChat',
            apiBaseUrl: DEFAULT_API_BASE_URL,
            debug: false
        };
    }
}
export function createRuntimeConfigStore(initial) {
    let current = {
        appName: initial.appName || 'SkyChat',
        apiBaseUrl: normalizeBaseUrl(initial.apiBaseUrl),
        debug: initial.debug === true
    };
    const listeners = new Set();
    return {
        get: () => current,
        set: (next) => {
            current = {
                ...current,
                ...next,
                apiBaseUrl: normalizeBaseUrl(next.apiBaseUrl || current.apiBaseUrl)
            };
            listeners.forEach((listener) => listener(current));
            return current;
        },
        subscribe: (listener) => {
            listeners.add(listener);
            return () => listeners.delete(listener);
        }
    };
}
//# sourceMappingURL=config.js.map